import { addDays, format, isSameWeek, startOfWeek } from 'date-fns';

const WEEK_STARTS_ON = 1;

export function toLocalDate(date: string): Date {
  return new Date(`${date}T00:00:00`);
}

export function toIsoDate(date: Date): string {
  return format(date, 'yyyy-MM-dd');
}

export function getTodayIso(now = new Date()): string {
  return toIsoDate(now);
}

export function shiftIsoDate(date: string, days: number): string {
  return toIsoDate(addDays(toLocalDate(date), days));
}

export function getWeekScope(selectedDate: string, now = new Date()) {
  const date = toLocalDate(selectedDate);
  const weekStart = startOfWeek(date, { weekStartsOn: WEEK_STARTS_ON });
  const weekEnd = addDays(weekStart, 6);
  const weekDates = Array.from({ length: 7 }, (_, index) => toIsoDate(addDays(weekStart, index)));
  const endNeedsYear =
    format(weekStart, 'yyyy') !== format(weekEnd, 'yyyy') ||
    format(weekEnd, 'yyyy') !== format(now, 'yyyy');
  const rangeLabel = `${format(weekStart, 'MMM d')} - ${format(weekEnd, endNeedsYear ? 'MMM d, yyyy' : 'MMM d')}`;
  const isCurrentWeek = isSameWeek(weekStart, now, { weekStartsOn: WEEK_STARTS_ON });

  return {
    weekStart,
    weekEnd,
    weekDates,
    rangeLabel,
    headerLabel: isCurrentWeek ? `This week · ${rangeLabel}` : rangeLabel,
    isCurrentWeek,
  };
}
